import styled from 'styled-components';
import { GREY, WHITE, TEXT, PRIMARY } from '../../constants/colors';

export const ToolbarStyleOveride = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  cursor: ${(props) => props.create ? 'crosshair!important' : 'move'};
  .leaflet-control-attribution.leaflet-control {
    display: none!important;
  }
  .leaflet.leaflet-control-measure h3,.leaflet-measure-resultpopup h3{
    margin:0 0 12px 0;
    padding-bottom:10px;
    line-height:1em;
    font-weight:normal;
    font-size:1.1em;
    border-bottom:solid 1px ${GREY};
}
.leaflet-control-measure p,.leaflet-measure-resultpopup p{
    margin:10px 0 0;
    line-height:1em
}
.leaflet-control-measure p:first-child,.leaflet-measure-resultpopup p:first-child{
    margin-top:0
}
.leaflet-control-measure a,.leaflet-measure-resultpopup a{
    color:${PRIMARY};
    text-decoration:none
}
.leaflet-control-measure a:hover,.leaflet-measure-resultpopup a:hover{
    opacity:0.5;
    text-decoration:none
}
.leaflet-control-measure .tasks,.leaflet-measure-resultpopup .tasks{
    margin:12px 0 0;
    padding:10px 0 0;
    border-top:solid 1px ${GREY};
    list-style:none;
    list-style-image:none
}
.leaflet-control-measure .tasks li,.leaflet-measure-resultpopup .tasks li{
    display:inline;
    margin:0 10px 0 0
}
.leaflet-control-measure .tasks li:last-child,.leaflet-measure-resultpopup .tasks li:last-child{
    margin-right:0
}
.leaflet-control-measure .coorddivider,.leaflet-measure-resultpopup .coorddivider{
    color:${TEXT}
}
.leaflet-control-measure{
    background: ${WHITE};
    border-radius:5px;
    display: none;
    box-shadow: 0 5px 13px 0 rgba(0, 0, 0, 0.14);
}
.leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-control-measure .leaflet-control-measure-toggle:hover{
    display:block;
    width:36px;
    height:36px;
    background-position:50% 50%;
    background-repeat:no-repeat;
    background-image:url(images/rulers.png);
    border-radius:5px;
    text-indent:100%;
    white-space:nowrap;
    overflow:hidden
}
.leaflet-retina .leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-retina .leaflet-control-measure .leaflet-control-measure-toggle:hover{
    background-image:url(images/rulers_@2X.png);
    background-size:16px 16px
}
.leaflet-touch .leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-touch .leaflet-control-measure .leaflet-control-measure-toggle:hover{
    width:44px;
    height:44px
}
.leaflet-control-measure .startprompt h3{
    margin-bottom:10px
}
.leaflet-control-measure .startprompt .tasks{
    margin-top:0;
    padding-top:0;
    border-top:0
}
.leaflet-control-measure .leaflet-control-measure-interaction{
    padding:10px 12px
}
.leaflet-control-measure .results .group{
    margin-top:10px;
    padding-top:10px;
    border-top: dotted 1px #eaeaea
}
.leaflet-control-measure .results .group:first-child{
    margin-top:0;
    padding-top:0;
    border-top:0
}
.leaflet-control-measure .results .heading{
    margin-right:5px;
    color:${TEXT}
}
.leaflet-control-measure a.start{
    padding-left:18px;
    background-repeat:no-repeat;
    background-position:0% 50%;
    background-image:url(images/start.png);
    width: 100%;
}
.leaflet-retina .leaflet-control-measure a.start{
    background-image:url(images/start_@2X.png);
    background-size:12px 12px
}
.leaflet-control-measure a.cancel{
    padding-left:18px;
    background-repeat:no-repeat;
    background-position:0% 50%;
    background-image:url(images/cancel.png)
}
.leaflet-retina .leaflet-control-measure a.cancel{
    background-image:url(images/cancel_@2X.png);
    background-size:12px 12px
}
.leaflet-control-measure a.finish{
    padding-left:18px;
    background-repeat:no-repeat;
    background-position:0% 50%;
    background-image:url(images/check.png)
}
.leaflet-retina .leaflet-control-measure a.finish{
    background-image:url(images/check_@2X.png);
    background-size:12px 12px
}
.leaflet-measure-resultpopup a.zoomto{
    padding-left:18px;
    background-repeat:no-repeat;
    background-position:0% 50%;
    background-image:url(images/focus.png)
}
.leaflet-retina .leaflet-measure-resultpopup a.zoomto{
    background-image:url(images/focus_@2X.png);
    background-size:12px 12px
}
.leaflet-measure-resultpopup a.deletemarkup{
    padding-left:18px;
    background-repeat:no-repeat;
    background-position:0% 50%;
    background-image:url(images/trash.png)
}
.leaflet-retina .leaflet-measure-resultpopup a.deletemarkup{
    background-image:url(images/trash_@2X.png);
    background-size:11px 12px
}
`;



// WEBPACK FOOTER //
// ./src/containers/Map/ToolbarStyleOveride.js